interface RawUser {
  readonly id: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly email: string;
  readonly logoUrl: string;
  readonly groups: readonly string[];
  readonly rights?: readonly string[];
}

export class User {
  readonly id: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly email: string;
  readonly logoUrl: string;
  readonly groups: readonly string[];
  readonly rights: readonly string[];

  constructor(raw: RawUser) {
    this.id = raw.id;
    this.email = raw.email;
    this.firstName = raw.firstName;
    this.lastName = raw.lastName;
    this.logoUrl = raw.logoUrl;
    this.groups = raw.groups;
    this.rights = raw.rights ?? [];
  }

  public hasRight(right: string): boolean {
    return this.rights.includes(right);
  }

  public hasAnyRight(...rights: readonly string[]): boolean {
    if (rights.length === 0) {
      return false;
    }

    return rights.some((right: string): boolean => this.hasRight(right));
  }

  public hasAllRights(...rights: readonly string[]): boolean {
    if (rights.length === 0) {
      return false;
    }

    return rights.every((right: string): boolean => this.hasRight(right));
  }
}
